<template>
  <div class="cover-page page">
    <div class="illustration"></div>

    <div class="container">
      <div class="content" :class="{ 'has-logo': logo }">
        <div v-if="logo" class="client-logo" :style="{ backgroundImage: `url(${logo})` }"></div>
        <div class="logo-line">
          <div class="jll-logo"></div>
          <div class="divider-vertical"></div>
          <div class="commuter-logo">Commuter</div>
        </div>
        <div class="title">
          {{ name }}
        </div>
        <div class="client-name">
          {{ study.client_name }}
        </div>
        <div class="divider-horizontal"></div>
        <div class="confidential">{{ $t('confidential') }}</div>
      </div>

      <div class="footer">
        <div class="date">{{ formatDate(new Date()) }}</div>
        <div v-if="filters" class="focus">{{ $t('focusStudyOn') }} : {{ filters }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from '@/libraries/formatter';

export default {
  name: 'CoverPage',

  props: {
    study: {
      type: Object,
      required: false,
      default: () => ({}),
    },

    export: {
      type: Object,
      required: false,
      default: () => ({}),
    },

    filters: {
      type: String,
      required: false,
      default: null,
    },

    name: {
      type: String,
      required: false,
      default: null,
    },

    logo: {
      type: String,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      formatDate,
    };
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';

.cover-page {
  position: relative;

  .illustration {
    position: absolute;
    top: 0;
    right: 33%;
    bottom: 0;
    left: 0;
    background-image: url('./../../assets/Export-Cover.png');
    background-repeat: no-repeat;
    background-position: center right;
    background-size: cover;
  }

  .container {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 60%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 8px 24px 16px;
    box-sizing: border-box;

    .content {
      margin: 75% 0 0;

      &.has-logo {
        margin-top: 30%;
      }

      .client-logo {
        width: 256px;
        height: 192px;

        margin: 0 0 32px;

        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
      }

      .logo-line {
        display: flex;

        .jll-logo {
          width: 64px;
          height: 32px;
          margin: 0;

          background-image: url('./../../assets/JLLLogo-Color.png');
          background-repeat: no-repeat;
          background-position: center right;
          background-size: cover;
        }

        .divider-vertical {
          width: 1px;
          height: 28px;
          border-radius: 2px;
          margin: 2px 16px -2px 12px;
          background: #9b9b9b;
        }

        .commuter-logo {
          font-size: 32px;
          color: colors.$stone-color;
          font-family: 'Golden Plains';
        }
      }

      .title {
        margin: 32px 0 0 0;
        color: #0e0b1c;
        text-transform: uppercase;
        font-size: 2.2em;
        line-height: 1em;
        font-weight: bold;
        max-height: 104px;

        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .client-name {
        margin: 8px 0;
        color: #77797f;
        font-size: 1.6em;
        font-weight: 600;
      }

      .divider-horizontal {
        width: 48px;
        height: 4px;
        border-radius: 4px;
        background: colors.$main-color;
      }

      .confidential {
        margin-top: 32px;
        text-transform: uppercase;
        font-size: 2.2em;
        color: #77797f;
      }
    }

    .footer {
      display: flex;
      color: #9b9b9b;
      font-size: 0.8em;

      .focus {
        &::before {
          content: '';
          display: inline-block;
          width: 1px;
          height: 80%;
          border-radius: 2px;
          margin: 2px 8px -2px;
          background: #9b9b9b;
        }

        max-width: 320px;
        white-space: nowrap;
        overflow-x: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
